import { createFileRoute, redirect } from '@tanstack/react-router'
import { AssetOverview } from 'pages/assetDatabase/assetOverview/AssetOverview'
import { assetUnitPageSearchSchema } from 'routes/assets/-searchParams'

const RouteComponent = () => {
  const search = Route.useSearch()

  return <AssetOverview {...search} />
}

/**
 * DO NOT ROUTE DIRECTLY TO HERE, INSTEAD GO THROUGH /assets/routing TO ENSURE YOU END UP AT THE CORRECT DESTINATION
 */
export const Route = createFileRoute(
  '/assets/(single_asset_destinations)/unit'
)({
  validateSearch: assetUnitPageSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search.unitId) {
      throw redirect({
        to: '/assets',
        search: { siteId: search.siteId },
      })
    }
  },
  staticData: {
    title: 'Asset Details',
  },
  component: RouteComponent,
})
